import { render, staticRenderFns } from "./SectionWhySmartPOST.vue?vue&type=template&id=496a0b74&scoped=true"
import script from "./SectionWhySmartPOST.vue?vue&type=script&lang=ts"
export * from "./SectionWhySmartPOST.vue?vue&type=script&lang=ts"
import style0 from "./SectionWhySmartPOST.vue?vue&type=style&index=0&id=496a0b74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496a0b74",
  null
  
)

export default component.exports